const config = {
  apiBaseUrl: window.location.hostname === 'localhost'
    ? 'http://localhost:5000'
    : 'https://shreeohmonline.onrender.com',

  frontendBaseUrl: window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : 'https://shreeohmonline-frontend.onrender.com',
};

export default config;

